/**
 * @generated SignedSource<<e0360f1ac302c144ff81865c944fb10d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PuzzmoFragment$data = {
  readonly currentUser: {
    readonly " $fragmentSpreads": FragmentRefs<"PuzzmoCurrentUserFragment">;
  } | null;
  readonly userState: {
    readonly " $fragmentSpreads": FragmentRefs<"PuzzmoCurrentUserStateFragment">;
  };
  readonly " $fragmentType": "PuzzmoFragment";
};
export type PuzzmoFragment$key = {
  readonly " $data"?: PuzzmoFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"PuzzmoFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PuzzmoFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "currentUser",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PuzzmoCurrentUserFragment"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UserState",
      "kind": "LinkedField",
      "name": "userState",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PuzzmoCurrentUserStateFragment"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "265c4093c9bc4e65d135208f34c8ac5a";

export default node;
